export default __webpack_public_path__ + "static/media/backgroundmobile.fa20120e.png";